import { useState, useEffect, useRef } from "react";
import { Close } from "@mui/icons-material";
import SearchIcon from "../assets/searchIcon.svg";
import { Switch } from "@mui/material";
import { RpaServices } from "../services/RpaServices";
import { handleApiErrorResponses } from "../utils/ApisErrorHandling";
import CustomPagination from "../utils/paginationUtils";
import { HospitalServices } from "../services/HospitalServices";
import { toast } from "react-toastify";
const MappedHospitalsList = ({ setIsPopupVisible, application }) => {
  const [hospitals, setHospitals] = useState(null);
  const [page, setPage] = useState(1);
  const [searchKey, setSearchKey] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [openAssignModal, setOpenAssignModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedHospital, setSelectedHospital] = useState(null);
  const [applicationIds, setApplicationIds] = useState([]);
  const [selectedApplicationId, setSelectedApplicationId] = useState(null);

  let limit = 20;
  let searchTimeRef = useRef();
  const handleSearch = (e) => {
    //debouncing structure
    if (searchTimeRef.current) {
      clearInterval(searchTimeRef.current);
    }
    searchTimeRef.current = setTimeout(() => {
      setSearchKey(e.target.value);
    }, 500);
  };
  useEffect(() => {
    const getApplications = async () => {
      try {
        const response = await RpaServices.manageApplicationId();
        setApplicationIds(response.data.applications);
      } catch (error) {
        handleApiErrorResponses(error);
      }
    };
    getApplications();
  }, []);

  const handleAssign = async () => {
    setLoading(true);

    const payload = {
      hospitalId: selectedHospital?.id, // Use correct nested ID
      applicationId: selectedApplicationId,
      assignWithoutAddReq: true,
    };

    try {
      const response = await RpaServices.assignTempDevice(payload); // Use same working API

      toast.success(response.data.message || "Assigned successfully!");

      setOpenAssignModal(false);
    } catch (error) {
      console.error(error);
      toast.error(error?.response?.data?.error || "Assignment failed");
    }

    setLoading(false);
  };

  const handleOpenAssignModal = (hospital) => {
    setSelectedHospital(hospital);
    setSelectedApplicationId(hospital.applicationId || ""); // prefill if exists
    setOpenAssignModal(true);
  };

  const getapplicationsForApplicationId = async (id) => {
    setIsPopupVisible(true);
    try {
      const response = await RpaServices.getHospitalsFromId(
        id,
        page,
        searchKey,
        limit
      );

      setHospitals(response?.data?.hospitals);
      setTotalPages(response?.data?.totalPages);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  const handleHospitalStatusChange = async (hospital) => {
    const updatedStatus =
      hospital?.users[0].pmjaystatus === true ? false : true;
    const updatedData = {
      userid: hospital?.users[0]?.id,
      pmjaystatus: updatedStatus,
    };
    try {
      await HospitalServices.updateUserRpaDetails(updatedData);
      await getapplicationsForApplicationId(hospital?.applicationId, page);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  useEffect(() => {
    getapplicationsForApplicationId(application.applicationId);
  }, [page, searchKey]);
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => (document.body.style.overflow = "auto");
  }, []);

  return (
    <div className="popup-overlay overflow-y-auto">
      <div className="w-[90%] md:w-[70%] max-h-[92vh] bg-white rounded-[16px] mx-auto mt-6 mb-6 z-[1200]">
        {/* Header */}
        <div className="flex justify-between items-center px-4 sm:px-10 pt-5">
          <div className="font-semibold text-lg sm:text-xl">
            Mapped hospital(s)
          </div>

          <div className="flex items-center gap-2 rounded-[8px] px-3 py-[6px] border border-[#E4E4E4]">
            <img src={SearchIcon} alt="search-icon" />
            <input
              type="text"
              placeholder="Search anything"
              className="outline-none border-0 text-sm"
              onChange={handleSearch}
            />
          </div>

          <div className="cursor-pointer">
            <Close onClick={() => setIsPopupVisible(false)} />
          </div>
        </div>

        <div className="border-t border-[#E5E5E5] my-5" />

        {/* Table Section */}
        <div className="h-full">
          {hospitals && hospitals.length > 0 ? (
            <div className="overflow-y-auto max-h-[60vh] px-4 sm:px-10">
              <table className="w-full min-w-[600px] text-left text-sm">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="border p-2">Hospital Name</th>
                    <th className="border p-2">Admin Name</th>
                    <th className="border p-2">Phone Number</th>
                    <th className="border p-2">City</th>
                    <th className="border p-2">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {hospitals.map((hospital, index) => (
                    <tr key={index}>
                      <td className="border p-2">{hospital.name || "--"}</td>
                      <td className="border p-2">
                        {hospital.users?.[0]?.fullName || "--"}
                      </td>
                      <td className="border p-2">
                        {hospital.users?.[0]?.phone || "--"}
                      </td>
                      <td className="border p-2">{hospital.city || "--"}</td>
                      <td className="border p-2">
                        <Switch
                          checked={hospital?.users[0]?.pmjaystatus === true}
                          onChange={() => handleHospitalStatusChange(hospital)}
                          inputProps={{ "aria-label": "toggle status" }}
                          style={{
                            color: hospital?.pmjaystatus
                              ? "#017C57"
                              : "#B0B0B0",
                          }}
                          sx={{
                            "& .MuiSwitch-thumb": {
                              backgroundColor: hospital?.pmjaystatus
                                ? "#017C57"
                                : "#D3D3D3",
                            },
                            "& .MuiSwitch-track": {
                              backgroundColor: hospital?.pmjaystatus
                                ? "#017C57"
                                : "#D3D3D3",
                            },
                          }}
                        />
                        <div
                          className="text-white text-xs bg-[#017C57] px-3 py-1 rounded-full inline-block cursor-pointer"
                          onClick={() => handleOpenAssignModal(hospital)}
                        >
                          Temp Assign
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : hospitals && hospitals.length === 0 ? (
            <div className="text-gray-500 text-center mt-4">
              No hospital mapped
            </div>
          ) : (
            <div className="text-gray-500 text-center mt-4">Loading</div>
          )}
        </div>

        {openAssignModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-[1201]">
            <div className="bg-white rounded-2xl p-8 w-full max-w-md shadow-lg relative">
              <button
                className="absolute top-3 right-3 text-gray-500 hover:text-gray-700 focus:outline-none focus:ring-0 border-none bg-transparent p-0"
                onClick={() => setOpenAssignModal(false)}
                title="Close"
              >
                <Close className="w-5 h-5" /> {/* adjust size if needed */}
              </button>

              {/* Heading */}
              <h2 className="text-xl font-semibold text-gray-800 mb-6 text-center">
                Assign Application
              </h2>

              {/* Label + Select */}
              <div className="mb-6 flex items-center gap-4">
                <label
                  htmlFor="application-select"
                  className="text-sm font-medium text-gray-700 min-w-[120px]"
                >
                  Application ID:
                </label>
                <select
                  id="application-select"
                  value={selectedApplicationId}
                  onChange={(e) => setSelectedApplicationId(e.target.value)}
                  className="flex-1 border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-[#017C57]"
                >
                  <option value="">Select Application</option>
                  {applicationIds.map((app) => (
                    <option key={app.applicationId} value={app.applicationId}>
                      {app.applicationId} - {app.ownerName || "--"}
                    </option>
                  ))}
                </select>
              </div>

              {/* Assign Button */}
              <button
                onClick={handleAssign}
                className={`w-full bg-[#017C57] text-white px-4 py-2 rounded-lg hover:bg-green-700 transition border border-[#017C57] ${
                  loading ? "opacity-50 cursor-not-allowed" : ""
                }`}
                disabled={loading}
              >
                {loading ? "Assigning..." : "Assign"}
              </button>
            </div>
          </div>
        )}

        {/* Pagination */}
        <div className="w-full flex justify-center items-center py-3">
          <CustomPagination
            page={page}
            setPage={setPage}
            totalPages={totalPages}
          />
        </div>
      </div>
    </div>
  );
};

export default MappedHospitalsList;
